export { ConversationModel, MessageModel, UserModel } from '@deal/chat-firebase-client';

var ToastNotificationType;

(function (ToastNotificationType) {
  ToastNotificationType[ToastNotificationType["SUCCESS"] = 0] = "SUCCESS";
  ToastNotificationType[ToastNotificationType["ERROR"] = 1] = "ERROR";
})(ToastNotificationType || (ToastNotificationType = {}));

export { ToastNotificationType };
//# sourceMappingURL=index.js.map
